import { createContext } from 'react';

const faproContext = createContext({})

export default faproContext;